import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useGetOrderPrepartionTime } from '@api/tender/tenderApis.rq';

import { TenderItem, Tile, TileType } from './tiles.types';

const featureToEnumMap: Record<string, keyof typeof TileType> = {
  quickDelivery: 'OnlinePharmacy',
  campaign: 'OnlineConsultation',
  rare: 'Rare',
  newFeature: 'New',
};

interface TileFeaturedBadgeProps {
  featured: NonNullable<Tile['featured']>;
}

const TileFeaturedBadge = ({ featured }: TileFeaturedBadgeProps) => {
  const userLatLng = useSelector(
    (state: any) => state?.user?.user?.defaultAddress,
  );

  const tenderParams = useMemo(
    () => ({
      lat: userLatLng?.latitude,
      lng: userLatLng?.longitude,
    }),
    [userLatLng],
  );

  const { data: tenderData } = useGetOrderPrepartionTime(tenderParams);

  const targetEnumName = featureToEnumMap[featured];
  if (!targetEnumName || !tenderData) return null;

  const targetType = TileType[targetEnumName];
  const item = tenderData?.find(
    (tenderItem: TenderItem) => tenderItem.type === targetType,
  );
  const message = item?.message;
  if (!message) return null;

  return (
    <span className="text-white text-Label/2xSmall text-center absolute -top-[10px] -left-[5px] flex justify-center items-center w-auto h-[20px] bg-surface-accent rounded-full px-2 min-w-16">
      {message}
    </span>
  );
};

export default TileFeaturedBadge;
